import PageTitle from "@app/components/page-title.tsx";
import { Versions } from "@app/constants/versions.ts";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    List,
    ListItem,
    ListItemText,
    styled,
    Typography,
} from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

export const Route = createFileRoute("/change-log")({
    component: Component,
});

const StyledAccordionDetails = styled(AccordionDetails)`
    border-top: 1px solid #ccc;
`;

const StyledList = styled(List)`
    list-style-type: disc;
    padding: 0 0 0 2rem;
`;

const StyledListItem = styled(ListItem)`
    display: list-item;
    padding-top: 0;
    padding-bottom: 0;
`;

function Component() {
    const [expanded, setExpanded] = useState<number | undefined>(0);

    const triggerExpand = (key: number) => {
        if (expanded == key) {
            setExpanded(undefined);
            return;
        }
        setExpanded(key);
    };

    return (
        <>
            <PageTitle>Change Log</PageTitle>
            <Box mt={2} mx={2}>
                {Versions.map((version, i) => {
                    return (
                        <Accordion key={version.toString()} expanded={expanded == i} onClick={() => triggerExpand(i)}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography variant={"h5"} component={"h2"}>
                                    {version.toString()}
                                </Typography>
                            </AccordionSummary>
                            <StyledAccordionDetails>
                                {version.changes.features && (
                                    <ListRenderer title={"Features"} items={version.changes.features} />
                                )}
                                {version.changes.bugfixes && (
                                    <ListRenderer title={"Bug Fixes"} items={version.changes.bugfixes} />
                                )}
                            </StyledAccordionDetails>
                        </Accordion>
                    );
                })}
            </Box>
        </>
    );
}

function ListRenderer({ title, items }: { title: string; items: string[] }) {
    return (
        <Box>
            <Typography variant={"h6"} component={"h3"}>
                {title}
            </Typography>
            <StyledList>
                {items.map((item, i) => (
                    <StyledListItem key={i}>
                        <ListItemText>{item}</ListItemText>
                    </StyledListItem>
                ))}
            </StyledList>
        </Box>
    );
}
